import aulacode from "assets/images/icons/iconDashboard/aulacode.png";
import cat from "assets/images/icons/iconDashboard/cat.png";
import cow from "assets/images/icons/iconDashboard/cow.png";
import dog from "assets/images/icons/iconDashboard/dog.png";
import fleshChicken from "assets/images/icons/iconDashboard/fleshChicken.png";
import goat from "assets/images/icons/iconDashboard/goat.png";
import hen from "assets/images/icons/iconDashboard/hen.png";
import horse from "assets/images/icons/iconDashboard/horse.png";
import pig from "assets/images/icons/iconDashboard/pig.png";
import rabbit from "assets/images/icons/iconDashboard/rabbit.png";
import sheep from "assets/images/icons/iconDashboard/sheep.png";
import camel from "assets/images/icons/iconDashboard/camel.png";

export const ESPECE_CHIEN = "Chien";
export const ESPECE_CHAT = "Chat";
export const ESPECE_CHEVAL = "Cheval";
export const ESPECE_BOVIN = "Bovin";
export const ESPECE_CAPRIN = "Caprin";
export const ESPECE_OVIN = "Ovin";
export const ESPECE_PORCIN = "Porcin";
export const ESPECE_AULACODE = "Aulacode";
export const ESPECE_LAPIN = "Lapin";
export const ESPECE_POULET_CHAIR = "Poulet de chair";
export const ESPECE_PONDEUSE = "Poule pondeuse";
export const ESPECE_CAMEL = "Camelin";

export const IMG_ESPECE_CHAT = cat;
export const IMG_ESPECE_CHEVAL = horse;
export const IMG_ESPECE_BOVIN = cow;
export const IMG_ESPECE_CAPRIN = goat;
export const IMG_ESPECE_OVIN = sheep;
export const IMG_ESPECE_PORCIN = pig;
export const IMG_ESPECE_AULACODE = aulacode;
export const IMG_ESPECE_LAPIN = rabbit;
export const IMG_ESPECE_POULET_CHAIR = fleshChicken;
export const IMG_ESPECE_PONDEUSE = hen;
export const IMG_ESPECE_CHIEN = dog;

export const LIST_ESPECE_ELEVAGE = [
  { espece: ESPECE_BOVIN, especePlural: "Bovins", img: cow, backgroundColor: "rgba(34,139,34,1)" },
  {
    espece: ESPECE_CAPRIN,
    especePlural: "Caprins",
    img: goat,
    backgroundColor: "rgba(241, 90, 34, 1)",
  },
  {
    espece: ESPECE_OVIN,
    especePlural: "Ovins",
    img: sheep,
    backgroundColor: "rgba(90, 34, 139, 1)",
  },
  {
    espece: ESPECE_CAMEL,
    especePlural: "Camelins",
    img: camel,
    backgroundColor: "rgba(15, 10, 222, 1)",
  },
];
export const LIST_ESPECE_ELEVAGE_CIV = [
  { espece: ESPECE_BOVIN, especePlural: "Bovins", img: cow, backgroundColor: "rgba(34,139,34,1)" },
  {
    espece: ESPECE_CAPRIN,
    especePlural: "Caprins",
    img: goat,
    backgroundColor: "rgba(241, 90, 34, 1)",
  },
  {
    espece: ESPECE_OVIN,
    especePlural: "Ovins",
    img: sheep,
    backgroundColor: "rgba(90, 34, 139, 1)",
  },
  {
    espece: ESPECE_PORCIN,
    especePlural: "Porcins",
    img: pig,
    backgroundColor: "rgba(140, 133, 20, 1)",
  },
  {
    espece: ESPECE_AULACODE,
    especePlural: "Aulacodes",
    img: aulacode,
    backgroundColor: "rgba(110, 33, 20, 1)",
  },
  {
    espece: ESPECE_LAPIN,
    especePlural: "Lapins",
    img: rabbit,
    backgroundColor: "rgba(70, 41, 15, 1)",
  },
  {
    espece: ESPECE_POULET_CHAIR,
    especePlural: "Poulets de chair",
    img: fleshChicken,
    backgroundColor: "rgba(330, 13, 17, 1)",
  },
  {
    espece: ESPECE_PONDEUSE,
    especePlural: "Poules pondeuses",
    img: hen,
    backgroundColor: "rgba(25, 307, 45, 1)",
  },
];
export const LIST_ESPECE_TRANSHUMANCE = [
  { espece: ESPECE_BOVIN, especePlural: "Bovins", img: cow, backgroundColor: "rgba(34,139,34,1)" },
  {
    espece: ESPECE_CAPRIN,
    especePlural: "Caprins",
    img: goat,
    backgroundColor: "rgba(241, 90, 34, 1)",
  },
  {
    espece: ESPECE_OVIN,
    especePlural: "Ovins",
    img: sheep,
    backgroundColor: "rgba(90, 34, 139, 1)",
  },
];
export const LIST_ESPECE_COMPAGNIE = [
  { espece: ESPECE_CHIEN, especePlural: "Chiens", img: dog, backgroundColor: "rgba(34,139,34,1)" },
  {
    espece: ESPECE_CHAT,
    especePlural: "Chats",
    img: cat,
    backgroundColor: "rgba(241, 90, 34, 1)",
  },
  {
    espece: ESPECE_CHEVAL,
    especePlural: "Chevaux",
    img: horse,
    backgroundColor: "rgba(30, 123, 150, 1)",
  },
];
